/**
 * vue-i18n@8 实例初始化
 *
 * 运行时文案由 scripts/generate-locales.js 生成，导入 JSON 扁平 key-value。
 * 初始 locale 由 i18nInit.ts 在 boot 阶段调用 resolveLocale() 后设置。
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';
import elementEn from 'element-ui/lib/locale/lang/en';
import elementZhCN from 'element-ui/lib/locale/lang/zh-CN';
import zhCN from './locales/zh-CN.json';
import enUS from './locales/en-US.json';
import type { Locale } from './resolver';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  silentFallbackWarn: true,
  silentTranslationWarn: process.env.NODE_ENV === 'production',
  messages: {
    'zh-CN': zhCN as Record<string, string>,
    'en-US': enUS as Record<string, string>,
  },
});

/**
 * 应用 Element-UI 内建文案（MessageBox/Pagination/Table empty/DatePicker 周名 等）的 locale。
 * 供 i18nInit（启动时）与 switchLocale（切换时）调用；必须在 Vue.use(Element 组件) 之前或同时完成，
 * 但由于 ElementLocale.use 内部会通知已实例化的组件，切换时调用也能生效。
 */
export function applyElementLocale(locale: Locale): void {
  ElementLocale.use(locale === 'en-US' ? elementEn : elementZhCN);
}

export default i18n;
